import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { contentToHtml } from '../../utils/adfToHtml';

/**
 * Renders ticket description. Uses contentToHtml (ADF or plain) then DOMPurify.
 * This is the only permitted use of dangerouslySetInnerHTML; must stay paired with DOMPurify.
 */
export default function TicketDescription({ description }) {
  if (description == null || description === '') {
    return (
      <Card>
        <CardContent>
          <Typography color="text.secondary">No description.</Typography>
        </CardContent>
      </Card>
    );
  }
  const html = contentToHtml(description);
  const sanitized = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });

  return (
    <Card>
      <CardContent>
        <div aria-label="Ticket description" dangerouslySetInnerHTML={{ __html: sanitized }} />
      </CardContent>
    </Card>
  );
}
